export function Divider() {
	return (
		<div className="flex items-center gap-3">
			<div className="h-px flex-1 bg-brand-gray" />
			<span className=" text-[14px] text-brand-gray-secondary">or</span>
			<div className="h-px flex-1 bg-brand-gray" />
		</div>
	)
}
